import React, { useState, useEffect, useRef } from 'react';

const beltLevels = [
  {
    level: 'White Belt',
    questions: [
      { q: '10 + ___ = 17', a: '7' },
      { q: '5 + 2 = ?', a: '7' },
      { q: '9 - 3 = ?', a: '6' },
    ],
  },
  {
    level: 'Yellow Belt',
    questions: [
      { q: 'What’s half of 64?', a: '32' },
      { q: '10 × 1 = ?', a: '10' },
      { q: '8 + 4 = ?', a: '12' },
    ],
  },
  {
    level: 'Green Belt',
    questions: [
      { q: '3 × 4 + 6 = ?', a: '18' },
      { q: '9 × 2 = ?', a: '18' },
      { q: '15 ÷ 3 = ?', a: '5' },
    ],
  },
  {
    level: 'Black Belt',
    questions: [
      { q: 'What number is divisible by 2 and 3, but not by 5?', a: '6' },
      { q: '24 is divisible by?', a: '2' },
      { q: '15 + 3 = ?', a: '18' },
    ],
  },
];

const NumberNinjaDojo = () => {
  const [levelIndex, setLevelIndex] = useState(0);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [answer, setAnswer] = useState('');
  const [completed, setCompleted] = useState(false);

  const successSoundRef = useRef(null);

  const currentLevel = beltLevels[levelIndex];
  const currentQuestion = currentLevel?.questions[questionIndex];

  const checkAnswer = () => {
    if (!currentQuestion) return;

    if (answer.trim() === currentQuestion.a) {
      successSoundRef.current?.play();
      const newScore = score + 10;
      setScore(newScore);

      if (questionIndex + 1 < currentLevel.questions.length) {
        setQuestionIndex((prev) => prev + 1);
      } else if (levelIndex + 1 < beltLevels.length) {
        setLevelIndex((prev) => prev + 1);
        setQuestionIndex(0);
      } else {
        setCompleted(true);
      }
      setAnswer('');
    } else {
      alert('Oops! Try again, ninja 🥷');
    }
  };

  return (
    <div style={styles.body}>
      <h1>🥷 Number Ninja: Math Dojo Challenge 🥋</h1>
      <div style={styles.dojo}>
        <div style={styles.level}>{completed ? 'Math Master' : currentLevel.level}</div>
        <div style={styles.question}>{completed ? 'Well Done!' : currentQuestion.q}</div>
        {!completed && (
          <>
            <input
              type="text"
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              placeholder="Enter your answer"
              style={styles.input}
            />
            <br />
            <button style={styles.button} onClick={checkAnswer}>Submit</button>
          </>
        )}
        <div style={styles.score}>{completed ? `Final Score: ${score} ⭐` : `Score: ${score} ⭐`}</div>
      </div>
      <audio ref={successSoundRef} src="https://www.soundjay.com/buttons/sounds/button-3.mp3" preload="auto" />
    </div>
  );
};

const styles = {
  body: {
    fontFamily: 'Press Start 2P, cursive',
    background: 'linear-gradient(to bottom,rgb(139, 215, 248),rgb(56, 171, 210),rgb(39, 56, 63))',
    color: 'white',
    textAlign: 'center',
    padding: '20px',
  },
  dojo: {
    margin: '20px auto',
    padding: '20px',
    maxWidth: '600px',
    border: '5px dashed #FFD700',
    borderRadius: '20px',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },
  level: {
    fontSize: '22px',
    marginBottom: '15px',
    color: '#00FF99',
  },
  question: {
    fontSize: '20px',
    marginBottom: '20px',
  },
  input: {
    padding: '10px',
    fontSize: '16px',
    borderRadius: '10px',
    border: 'none',
    textAlign: 'center',
  },
  button: {
    marginTop: '10px',
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: '#FFD700',
    color: 'black',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
  },
  score: {
    marginTop: '20px',
    fontSize: '18px',
  },
};

export default NumberNinjaDojo;
